import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Typography, Card,
  CardContent,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PublicIcon from "@mui/icons-material/Public";
import FlagIcon from "@mui/icons-material/Flag";
import Webhead from '../website/Webhead';
import Webfoot from '../website/Webfoot';

const contactInfo = [
  // { icon: <FlagIcon />, label: "Australia", value: "" },
  { icon: <PhoneIcon />, label: "Phone", value: "+61423632306" },
  { icon: <EmailIcon />, label: "Email", value: "contact@trentinternational.com.au info@trentinternational.com.au" },
  // { icon: <EmailIcon />, label: "Info Email", value: "info@trentinternational.com.au" },
  { icon: <LocationOnIcon />, label: "Address", value: "17 128 Brown Street, East Perth, WA 6004 Australia" },
  { icon: <PublicIcon />, label: "Website", value: "www.trentinternational.com.au" },
];

const locations = [
    {
      city: "Perth",
      address: "17 128 Brown Street, East Perth, WA (Western Australia), 6004 Australia.",
      phone: "+61 423632306",
    },
    {
      city: "Sydney",
      address: "479, Great Western Highway, Greystanes, 2147",
      phone: "+61 470249149",
    },
    {
      city: "Singapore Branch",
      address: "89 Short Street, #09-08B, Golden Wall Center, Singapore – 188216",
      phone: "+65 86006494",
    },
    {
      city: "India Branch",
      address: "749, 3rd Floor, TSJ Complex, Anna Statue Signal, Avinashi Road, Coimbatore – 641018",
      phone: "+91 89739 87737",
    },
  ];


const ContactUs = () => {
  return (
    <Container sx={{ py: 8 }}>
     

      <Grid container spacing={6}>
        {/* Contact Info Section */}
        
        <Grid item xs={12} md={4}>
            
          <Box sx={{ p: 4 }}>
            <Typography
              variant="h5"
              fontWeight={600}
              textAlign="left"
              gutterBottom
              sx={{ color: "#F9A825", mb: 3 }} // Yellow Subheading
            >
              Get in Touch
            </Typography>
            <Stepper orientation="vertical" activeStep={-1} connector={null}>
              {contactInfo.map((info, index) => (
                <Step key={index}>
                  <StepLabel
                    icon={info.icon} // Use Icon instead of number
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box>
                      <Typography variant="h6" fontWeight={500}>
                        {info.label}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "gray" }}>
                        {info.value}
                      </Typography>
                    </Box>
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Grid>

        {/* Contact Form */}
        <Grid item xs={12} md={8}>
        <Typography
        variant="h3"
        fontWeight={700}
        textAlign="left"
        gutterBottom
        sx={{ color: "#F9A825" }} // Yellow Heading
      >
        Contact Us
      </Typography>
          <Paper elevation={3} sx={{ p: 5, bgcolor: "#f9f9f9" }}>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Your Name"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Your Email"
                    type="email"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Your Mobile"
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Your Course"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Message"
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    type="submit"
                    sx={{ fontWeight: 600 }}
                  >
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>

      <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            sx={{ color: "#F9A825", mb: 3 }} // Yellow Subheading
          >
            Our Locations
          </Typography>
          

    {/* Horizontal Card Layout */}
    <Grid container spacing={3} justifyContent="space-between">
            {locations.map((location, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  sx={{
                    boxShadow: 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <CardContent>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      {location.city}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                      <LocationOnIcon sx={{ mr: 1, color: "primary.main" }} />
                      <Typography variant="body2" color="textSecondary">
                        {location.address}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
                      <Typography variant="body2" color="textSecondary">
                        {location.phone}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
       

    </Container>
  );
};

const Con = () => {
    return (
      <div>
        <Webhead />
        <div>
          <ContactUs />
        </div>
        <Webfoot />
      </div>
    );
  };
  
  export default Con;
  
